export const privacyPolicy = `

<!DOCTYPE html>
<html>
<head>
	<meta http-equiv="content-type" content="text/html; charset=utf-8"/>
	<title></title>
	<meta name="generator" content="LibreOffice 24.8.1.2 (Linux)"/>
	<meta name="author" content="Juda Panjaitan"/>
	<meta name="created" content="2026-01-13T03:41:00"/>
	<meta name="changedby" content="Radika Husaini Ondo"/>
	<meta name="changed" content="2026-01-15T06:46:00"/>
	<meta name="AppVersion" content="16.0000"/>
	<style type="text/css">
		@page { size: 8.27in 11.69in; margin: 1in }
		p { line-height: 115%; text-align: left; orphans: 2; widows: 2; margin-bottom: 0.1in; direction: ltr; background: transparent }
		a:link { color: #467886; text-decoration: underline }
	</style>
</head>
<body lang="en-US" link="#467886" vlink="#800000" dir="ltr"><p align="justify" style="margin-bottom: 0in">
<h3 align="justify" style="margin-bottom: 10px; fontSize: 23px"><b>PRIVACY POLICY</b></h3>
<p align="justify" style="margin-bottom: 30px">Last Updated:
January 15<sup>th</sup>,2026</p>
<ul>
	<ol>
		<li><p align="justify" style="margin-bottom: 0in"><b>Scope &amp;
		Introduction</b></p></li>
	</ol>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">This
Privacy Policy applies specifically to the website
https://dreamus-online.id/ (“Website”), which is managed by PT
Dreamus Edutainment Indonesia (“Company”, “we”).</span></p>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">This
Website is used as the official platform for digital services,
information, and transactions related to brands and business units
under the Company’s management, including but not limited to
SuperPark, Pororo Park, and Tayo Station.</span></p>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">This
Privacy Policy explains how we collect, use, store, disclose, and
protect your Personal Data in accordance with Law of the Republic of
Indonesia Number 27 of 2022 concerning Personal Data Protection (“PDP
Law”).</span></p>
<p align="justify" style="margin-bottom: 0.11in"><span lang="en-ID">By
accessing or using this Site, you are deemed to have read,
understood, and agreed to the management of Personal Data as
stipulated in this Privacy Policy.</span></p>
<ul>
	<ol start="2">
		<li><p align="justify" style="margin-bottom: 0in"><b>Definitions</b></p></li>
	</ol>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">In
this Privacy Policy:</span></p>
<ul>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Personal
	Data is any information relating to an identified or identifiable
	individual, either directly or indirectly.</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Data
	Subject is the individual who owns the Personal Data.</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Data
	Processing includes any action taken with regard to Personal Data,
	including collection, recording, storage, use, disclosure, and
	deletion.</span></p></li>
</ul>
<p lang="en-ID" align="justify" style="margin-left: 0.5in; margin-bottom: 0.11in">
<br/>

</p>
<ul>
	<ol start="3">
		<li><p align="justify" style="margin-bottom: 0in"><b>Types of
		Personal Data Collected</b></p></li>
	</ol>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Children's
personal data is included in the specific Personal Data as referred
to in the PDP Law and is processed with a higher level of protection.</span></p>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Through
the dreamus-online.id website, we may collect the following Personal
Data:</span></p>
<ul>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Name
	of parent or guardian</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Child's
	name and date of birth</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Email
	address and telephone number</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Information
	on ticket transactions, memberships, reservations, or activities</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Information
	on communications or correspondence with us</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Technical
	data such as IP address, device type, browser, cookies, and website
	activity logs</span></p></li>
</ul>
<p lang="en-ID" align="justify" style="margin-left: 0.5in; margin-bottom: 0.11in">
<br/>

</p>
<ul>
	<ol start="4">
		<li><p align="justify" style="margin-bottom: 0in"><b>Purposes of
		Data Processing</b></p></li>
	</ol>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Personal
Data is processed for the following purposes:</span></p>
<ul>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Provision
	of digital services, information, and transactions through the
	Website</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Administration
	of tickets, memberships, and customer services</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Processing
	of payments and transactions</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Handling
	of enquiries, requests, suggestions, or complaints</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Operational
	communications, service updates, and promotions (if approved)</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Maintaining
	security, safety, and operational compliance</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Internal
	analysis for service quality and user experience improvement</span></p></li>
</ul>
<p lang="en-ID" align="justify" style="margin-left: 0.5in; margin-bottom: 0.11in">
<br/>

</p>
<ul>
	<ol start="5">
		<li><p align="justify" style="margin-bottom: 0in"><b>Legal Basis
		for Processing</b></p></li>
	</ol>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Personal
Data Processing is carried out based on:</span></p>
<ul>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Data
	Subject Consent</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Execution
	of an agreement or provision of services</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Applicable
	legal obligations</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">The
	Company's legitimate interests in accordance with laws and
	regulations, as long as they do not override the rights and freedoms
	of the personal data subject</span></p></li>
</ul>
<p lang="en-ID" align="justify" style="margin-bottom: 0in"><br/>

</p>
<ul>
	<ol start="6">
		<li><p align="justify" style="margin-bottom: 0in"><b>Cookies and
		Similar Technologies</b></p></li>
	</ol>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">In
accordance with Permenkominfo 20/2016 regarding approval for
electronic data processing, this website uses cookies and similar
technologies to:</span></p>
<ul>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Maintain
	the proper functioning of the Website</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Analyse
	the use and performance of the Website</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Improve
	the user experience</span></p></li>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">You
can manage or disable cookies through your browser settings. However,
some features of the Website may not function optimally if cookies
are disabled.</span></p>
<p align="justify" style="margin-bottom: 0in"><br/>

</p>
<ul>
	<ol start="7">
		<li><p align="justify" style="margin-bottom: 0in"><b>Disclosure of
		Personal Data to Third Parties</b></p></li>
	</ol>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">We
do not sell your Personal Data.</span></p>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Personal
Data may be shared on a limited basis with:</span></p>
<ul>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Technology
	and payment system providers</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Operational
	partners who support the provision of services through the Site</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Authorities
	when required by law</span></p></li>
</ul>
<p align="justify" style="margin-bottom: 0in"><br/>

</p>
<ul>
	<ol start="8">
		<li><p align="justify" style="margin-bottom: 0in"><b>Personal Data
		Protection and Security</b></p></li>
	</ol>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">We
implement reasonable administrative, technical, and organisational
measures to protect Personal Data from unauthorised access, loss,
misuse, or unauthorised disclosure. However, it should be understood
that no method of data transmission over the internet or electronic
storage is completely secure. Therefore, although we strive to
maintain the security of Personal Data, we cannot guarantee its
absolute security. This statement is not intended to limit the
Company's liability as stipulated in the applicable laws and
regulations.</span></p>
<p lang="en-ID" align="justify" style="margin-bottom: 0in"><br/>

</p>
<ul>
	<ol start="9">
		<li><p align="justify" style="margin-bottom: 0in"><b>Data Retention</b></p></li>
	</ol>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Personal
Data is stored for as long as necessary to fulfil the purposes of
processing as described in this Privacy Policy, and/or for as long as
required by applicable laws and regulations.</span></p>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Once
the purposes of processing have been fulfilled or the retention
period has expired, personal data will be:</span></p>
<ul>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Deleted</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Destroyed,
	or</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Anonymised</span></p></li>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">In
accordance with legal provisions and the Company's internal policies,
unless further storage is required by law, dispute resolution, or
legitimate evidentiary interests.</span></p>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">The
Company periodically reviews the need for personal data storage to
ensure compliance with personal data protection principles.</span></p>
<p align="justify" style="margin-bottom: 0in"><br/>

</p>
<ul>
	<ol start="10">
		<li><p align="justify" style="margin-bottom: 0in"><b>Data Subject
		Rights</b></p></li>
	</ol>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">In
accordance with Law of the Republic of Indonesia Number 27 of 2022
concerning Personal Data Protection, you have the following rights:</span></p>
<ul>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Access
	and obtain a copy of Personal Data processed by the Company</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Complete,
	correct or update Personal Data that is inaccurate or incomplete</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Withdraw
	consent for the processing of Personal Data at any time, provided
	that this does not conflict with the provisions of applicable laws
	and regulations</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Request
	the deletion or destruction of Personal Data in accordance with
	applicable legal provisions</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Obtain
	information regarding the identity, legal basis, purpose of
	processing, and accountability of the party processing Personal Data</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Object
	to the processing of Personal Data</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Request
	restrictions on the processing of Personal Data</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Obtain
	and/or use Personal Data in a structured, commonly used, and
	machine-readable format (right to data portability)</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Lodge
	a complaint with the Company and/or supervisory authority regarding
	alleged violations of Personal Data protection</span></p></li>
	<li><p align="justify" style="margin-bottom: 0in"><span lang="en-ID">Obtain
	compensation for violations of Personal Data processing in
	accordance with the provisions of laws and regulations.</span></p></li>
</ul>
<p align="justify" style="margin-bottom: 0in"><br/>

</p>
<ul>
	<ol start="11">
		<li><p align="justify" style="margin-bottom: 0in"><b>Children’s
		Data</b></p></li>
	</ol>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">This
website is intended for use by families and children with the consent
and supervision of a parent or legal guardian. In this Privacy
Policy, a child is defined as an individual under the age of 18
(eighteen) or any other age as determined by applicable laws and
regulations. The Company only collects and processes Children's
Personal Data with the explicit consent of a parent or legal
guardian, and for purposes limited to the provision of services,
safety, security, and legitimate administrative obligations. The
Company takes reasonable steps to ensure that the consenting party is
the parent or legal guardian of the child concerned. Children's
Personal Data will not be used for direct marketing or other
commercial purposes without the separate consent of the parent or
legal guardian. Children's Personal Data is stored for a limited
period of time and will be deleted, destroyed, or anonymised once the
purpose of processing has been achieved, unless otherwise required by
applicable law. Parents or legal guardians have the right to access,
correct, withdraw consent, and request the deletion of a child's
Personal Data in accordance with applicable laws and regulations.</span></p>
<p align="justify" style="margin-bottom: 0in"><br/>

</p>
<ul>
	<ol start="12">
		<li><p align="justify" style="margin-bottom: 0in"><b>Changes to
		This Privacy Policy</b></p></li>
	</ol>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">We
may update this Privacy Policy from time to time. The latest version
will be published on the website and will take effect from the date
of update.</span></p>
<p align="justify" style="margin-bottom: 0in"><br/>

</p>
<ul>
	<ol start="13">
		<li><p align="justify" style="margin-bottom: 0in"><b>Company
		Contact</b></p></li>
	</ol>
</ul>
<p align="justify" style="margin-bottom: 0in"><span lang="en-ID">The
Company acts as the controller of Personal Data processed through
this website. Requests related to Personal Data will be handled by
the unit or personnel appointed by the Company in accordance with the
provisions of applicable laws and regulations. For questions,
requests, or complaints regarding the processing and protection of
Personal Data, including the exercise of data subject rights, please
contact:</span></p>
<p lang="en-ID" align="justify" style="margin-bottom: 0in"><br/>

</p>
<table width="312" cellpadding="7" cellspacing="0">
	<col width="296"/>
	<tr>
		<td width="296" valign="top" style="border: 1px solid #000000; padding: 0in 0.08in"><p align="justify" style="orphans: 2; widows: 2; margin-bottom: 0in">
			<font face="Aptos, serif"><font size="3" style="font-size: 12pt"><span lang="en-ID"><b>PT
			Dreamus Edutainment Indonesia</b></span></font></font></p>
			<p align="justify" style="orphans: 2; widows: 2; margin-bottom: 0in">
			<font face="Aptos, serif"><font size="3" style="font-size: 12pt"><span lang="en-ID">c.q.
			Guest Experience (GE) - SuperPark PIM</span></font></font></p>
			<p align="justify" style="orphans: 2; widows: 2; margin-bottom: 0in">
			<font face="Aptos, serif"><font size="3" style="font-size: 12pt"><span lang="en-ID">Contact
			Person: Tiara</span></font></font></p>
			<p align="justify" style="orphans: 2; widows: 2"><font face="Aptos, serif"><font size="3" style="font-size: 12pt"><span lang="en-ID">Email:
			superpark.pim@dreamusgroup.com</span></font></font></p>
		</td>
	</tr>
</table>
<p align="justify" style="margin-bottom: 0in"><br/>

</p>
<p align="justify" style="margin-bottom: 0in"><br/>

</p>
</body>
</html>

`;